
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import { State, Toggle } from 'react-powerplug'
import FormFieldSelect from './form-field-select'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "formfieldselect"
    }}>{`FormFieldSelect`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Forms`}</p>
    <hr />
    <h2 {...{
      "id": "select-field"
    }}>{`Select field`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`For providing a menu of options.`}</p>
    <p><strong parentName="p">{`Default`}</strong></p>
    <Playground __position={1} __code={'<State\n  initial={{\n    value: \'\',\n    options: [\n      { label: \'Option 1\', value: \'1\' },\n      { label: \'Option 2\', value: \'2\' },\n      { label: \'Option 3\', value: \'3\' },\n    ],\n  }}\n>\n  {({ state, setState }) => (\n    <FormFieldSelect\n      {...state}\n      labelText=\"Label\"\n      id=\"123\"\n      onChange={e => setState({ value: e.target.value })}\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldSelect
    }} mdxType="Playground">
  <State initial={{
        value: '',
        options: [{
          label: 'Option 1',
          value: '1'
        }, {
          label: 'Option 2',
          value: '2'
        }, {
          label: 'Option 3',
          value: '3'
        }]
      }} mdxType="State">
  {({
          state,
          setState
        }) => <FormFieldSelect {...state} labelText="Label" id="123" onChange={e => setState({
          value: e.target.value
        })} mdxType="FormFieldSelect" />}
      </State>
    </Playground>
    <p><strong parentName="p">{`Validation`}</strong></p>
    <Playground __position={2} __code={'<State\n  initial={{\n    value: \'\',\n    options: [\n      { label: \'Option 1\', value: \'1\' },\n      { label: \'Option 2\', value: \'2\' },\n      { label: \'Option 3\', value: \'3\' },\n    ],\n  }}\n>\n  {({ state, setState }) => (\n    <FormFieldSelect\n      {...state}\n      error=\"Notice\"\n      labelText=\"Label\"\n      id=\"123\"\n      onChange={e => setState({ value: e.target.value })}\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldSelect
    }} mdxType="Playground">
  <State initial={{
        value: '',
        options: [{
          label: 'Option 1',
          value: '1'
        }, {
          label: 'Option 2',
          value: '2'
        }, {
          label: 'Option 3',
          value: '3'
        }]
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldSelect {...state} error="Notice" labelText="Label" id="123" onChange={e => setState({
          value: e.target.value
        })} mdxType="FormFieldSelect" />}
  </State>
    </Playground>
    <p><strong parentName="p">{`Disabled`}</strong></p>
    <Playground __position={3} __code={'<State\n  initial={{\n    value: \'2\',\n    options: [\n      { label: \'Option 1\', value: \'1\' },\n      { label: \'Option 2\', value: \'2\' },\n      { label: \'Option 3\', value: \'3\' },\n    ],\n  }}\n>\n  {({ state, setState }) => (\n    <FormFieldSelect\n      {...state}\n      disabled\n      labelText=\"Label\"\n      id=\"123\"\n      onChange={e => setState({ value: e.target.value })}\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldSelect
    }} mdxType="Playground">
    <State initial={{
        value: '2',
        options: [{
          label: 'Option 1',
          value: '1'
        }, {
          label: 'Option 2',
          value: '2'
        }, {
          label: 'Option 3',
          value: '3'
        }]
      }} mdxType="State">
        {({
          state,
          setState
        }) => <FormFieldSelect {...state} disabled labelText="Label" id="123" onChange={e => setState({
          value: e.target.value
        })} mdxType="FormFieldSelect" />}
      </State>
    </Playground>
    <p><strong parentName="p">{`Helper`}</strong></p>
    <Playground __position={4} __code={'<State\n  initial={{\n    value: \'\',\n    options: [\n      { label: \'Option 1\', value: \'1\' },\n      { label: \'Option 2\', value: \'2\' },\n      { label: \'Option 3\', value: \'3\' },\n    ],\n  }}\n>\n  {({ state, setState }) => (\n    <FormFieldSelect\n      {...state}\n      helperText=\"Helper text\"\n      labelText=\"Label\"\n      id=\"123\"\n      onChange={e => setState({ value: e.target.value })}\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldSelect
    }} mdxType="Playground">
  <State initial={{
        value: '',
        options: [{
          label: 'Option 1',
          value: '1'
        }, {
          label: 'Option 2',
          value: '2'
        }, {
          label: 'Option 3',
          value: '3'
        }]
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldSelect {...state} helperText="Helper text" labelText="Label" id="123" onChange={e => setState({
          value: e.target.value
        })} mdxType="FormFieldSelect" />}
  </State>
    </Playground>
    <p><strong parentName="p">{`defaultValue`}</strong></p>
    <Playground __position={5} __code={'<State\n  initial={{\n    options: [\n      { label: \'Option 1\', value: \'1\' },\n      { label: \'Option 2\', value: \'2\' },\n      { label: \'Option 3\', value: \'3\' },\n    ],\n  }}\n>\n  {({ state, setState }) => (\n    <FormFieldSelect\n      {...state}\n      labelText=\"Label\"\n      id=\"123\"\n      defaultValue=\"3\"\n      onChange={e => setState({ value: e.target.value })}\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldSelect
    }} mdxType="Playground">
  <State initial={{
        options: [{
          label: 'Option 1',
          value: '1'
        }, {
          label: 'Option 2',
          value: '2'
        }, {
          label: 'Option 3',
          value: '3'
        }]
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldSelect {...state} labelText="Label" id="123" defaultValue='3' onChange={e => setState({
          value: e.target.value
        })} mdxType="FormFieldSelect" />}
  </State>
    </Playground>
    <hr />
    <h2 {...{
      "id": "select-field-adjacent"
    }}>{`Select field (adjacent)`}</h2>
    <h3 {...{
      "id": "description-1"
    }}>{`Description`}</h3>
    <p>{`For providing a menu of options.`}</p>
    <p><strong parentName="p">{`Avoid including `}<inlineCode parentName="strong">{`error`}</inlineCode>{`, `}<inlineCode parentName="strong">{`labelTag`}</inlineCode>{` and `}<inlineCode parentName="strong">{`helperText`}</inlineCode>{` props when using adjacent layout. Instead, use the standard layout.`}</strong></p>
    <p><strong parentName="p">{`Default`}</strong></p>
    <Playground __position={7} __code={'<State\n  initial={{\n    value: \'\',\n    options: [\n      { label: \'Option 1\', value: \'1\' },\n      { label: \'Option 2\', value: \'2\' },\n      { label: \'Option 3\', value: \'3\' },\n    ],\n  }}\n>\n  {({ state, setState }) => (\n    <FormFieldSelect\n      adjacent\n      {...state}\n      labelText=\"Label\"\n      id=\"123\"\n      onChange={e => setState({ value: e.target.value })}\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldSelect
    }} mdxType="Playground">
  <State initial={{
        value: '',
        options: [{
          label: 'Option 1',
          value: '1'
        }, {
          label: 'Option 2',
          value: '2'
        }, {
          label: 'Option 3',
          value: '3'
        }]
      }} mdxType="State">
  {({
          state,
          setState
        }) => <FormFieldSelect adjacent {...state} labelText="Label" id="123" onChange={e => setState({
          value: e.target.value
        })} mdxType="FormFieldSelect" />}
      </State>
    </Playground>
    <hr />
    <h2 {...{
      "id": "select-field-slim"
    }}>{`Select field (slim)`}</h2>
    <h3 {...{
      "id": "description-2"
    }}>{`Description`}</h3>
    <p>{`For providing a menu of options. Use where inputs are nested or constrained by layout.`}</p>
    <p><strong parentName="p">{`Default`}</strong></p>
    <Playground __position={9} __code={'<State\n  initial={{\n    value: \'\',\n    options: [\n      { label: \'Option 1\', value: \'1\' },\n      { label: \'Option 2\', value: \'2\' },\n      { label: \'Option 3\', value: \'3\' },\n    ],\n  }}\n>\n  {({ state, setState }) => (\n    <FormFieldSelect\n      {...state}\n      labelText=\"Label\"\n      id=\"123\"\n      onChange={e => setState({ value: e.target.value })}\n      slim\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldSelect
    }} mdxType="Playground">
  <State initial={{
        value: '',
        options: [{
          label: 'Option 1',
          value: '1'
        }, {
          label: 'Option 2',
          value: '2'
        }, {
          label: 'Option 3',
          value: '3'
        }]
      }} mdxType="State">
  {({
          state,
          setState
        }) => <FormFieldSelect {...state} labelText="Label" id="123" onChange={e => setState({
          value: e.target.value
        })} slim mdxType="FormFieldSelect" />}
      </State>
    </Playground>
    <p><strong parentName="p">{`Validation`}</strong></p>
    <Playground __position={10} __code={'<State\n  initial={{\n    value: \'\',\n    options: [\n      { label: \'Option 1\', value: \'1\' },\n      { label: \'Option 2\', value: \'2\' },\n      { label: \'Option 3\', value: \'3\' },\n    ],\n  }}\n>\n  {({ state, setState }) => (\n    <FormFieldSelect\n      {...state}\n      error=\"Notice\"\n      labelText=\"Label\"\n      id=\"123\"\n      onChange={e => setState({ value: e.target.value })}\n      slim\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldSelect
    }} mdxType="Playground">
  <State initial={{
        value: '',
        options: [{
          label: 'Option 1',
          value: '1'
        }, {
          label: 'Option 2',
          value: '2'
        }, {
          label: 'Option 3',
          value: '3'
        }]
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldSelect {...state} error="Notice" labelText="Label" id="123" onChange={e => setState({
          value: e.target.value
        })} slim mdxType="FormFieldSelect" />}
  </State>
    </Playground>
    <p><strong parentName="p">{`Disabled`}</strong></p>
    <Playground __position={11} __code={'<State\n  initial={{\n    value: \'2\',\n    options: [\n      { label: \'Option 1\', value: \'1\' },\n      { label: \'Option 2\', value: \'2\' },\n      { label: \'Option 3\', value: \'3\' },\n    ],\n  }}\n>\n  {({ state, setState }) => (\n    <FormFieldSelect\n      {...state}\n      disabled\n      labelText=\"Label\"\n      id=\"123\"\n      onChange={e => setState({ value: e.target.value })}\n      slim\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldSelect
    }} mdxType="Playground">
    <State initial={{
        value: '2',
        options: [{
          label: 'Option 1',
          value: '1'
        }, {
          label: 'Option 2',
          value: '2'
        }, {
          label: 'Option 3',
          value: '3'
        }]
      }} mdxType="State">
        {({
          state,
          setState
        }) => <FormFieldSelect {...state} disabled labelText="Label" id="123" onChange={e => setState({
          value: e.target.value
        })} slim mdxType="FormFieldSelect" />}
      </State>
    </Playground>
    <p><strong parentName="p">{`Helper`}</strong></p>
    <Playground __position={12} __code={'<State\n  initial={{\n    value: \'\',\n    options: [\n      { label: \'Option 1\', value: \'1\' },\n      { label: \'Option 2\', value: \'2\' },\n      { label: \'Option 3\', value: \'3\' },\n    ],\n  }}\n>\n  {({ state, setState }) => (\n    <FormFieldSelect\n      {...state}\n      helperText=\"Helper text\"\n      labelText=\"Label\"\n      id=\"123\"\n      onChange={e => setState({ value: e.target.value })}\n      slim\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldSelect
    }} mdxType="Playground">
  <State initial={{
        value: '',
        options: [{
          label: 'Option 1',
          value: '1'
        }, {
          label: 'Option 2',
          value: '2'
        }, {
          label: 'Option 3',
          value: '3'
        }]
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldSelect {...state} helperText="Helper text" labelText="Label" id="123" onChange={e => setState({
          value: e.target.value
        })} slim mdxType="FormFieldSelect" />}
  </State>
    </Playground>
    <hr />
    <h2 {...{
      "id": "select-field-slim-adjacent"
    }}>{`Select field (slim, adjacent)`}</h2>
    <h3 {...{
      "id": "description-3"
    }}>{`Description`}</h3>
    <p>{`For providing a menu of options. Use where inputs are nested or constrained by layout.`}</p>
    <p><strong parentName="p">{`Avoid including `}<inlineCode parentName="strong">{`error`}</inlineCode>{`, `}<inlineCode parentName="strong">{`labelTag`}</inlineCode>{` and `}<inlineCode parentName="strong">{`helperText`}</inlineCode>{` props when using adjacent layout. Instead, use the standard layout.`}</strong></p>
    <p><strong parentName="p">{`Default`}</strong></p>
    <Playground __position={14} __code={'<State\n  initial={{\n    value: \'\',\n    options: [\n      { label: \'Option 1\', value: \'1\' },\n      { label: \'Option 2\', value: \'2\' },\n      { label: \'Option 3\', value: \'3\' },\n    ],\n  }}\n>\n  {({ state, setState }) => (\n    <FormFieldSelect\n      adjacent\n      {...state}\n      labelText=\"Label\"\n      id=\"123\"\n      onChange={e => setState({ value: e.target.value })}\n      slim\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldSelect
    }} mdxType="Playground">
  <State initial={{
        value: '',
        options: [{
          label: 'Option 1',
          value: '1'
        }, {
          label: 'Option 2',
          value: '2'
        }, {
          label: 'Option 3',
          value: '3'
        }]
      }} mdxType="State">
  {({
          state,
          setState
        }) => <FormFieldSelect adjacent {...state} labelText="Label" id="123" onChange={e => setState({
          value: e.target.value
        })} slim mdxType="FormFieldSelect" />}
      </State>
    </Playground>
    <hr />
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={FormFieldSelect} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;